import { mergeSxProps } from "@clipboard-health/ui-components";
import { Stack, type StackProps } from "@mui/material";
import { type ForwardedRef, forwardRef } from "react";

// FIXME: Automatically disabled during ESLint config update
interface DocumentCardsWrapperProps extends StackProps {}

function BaseDocumentCardsWrapper(
  props: DocumentCardsWrapperProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const { sx, ...rest } = props;

  return <Stack spacing={4} sx={mergeSxProps({ overflowY: "scroll" }, sx)} {...rest} ref={ref} />;
}

export const DocumentCardsWrapper = forwardRef(BaseDocumentCardsWrapper);
